import { render } from "./CrudLicenca.vue?vue&type=template&id=201365fc&scoped=true"
import script from "./CrudLicenca.vue?vue&type=script&lang=ts"
export * from "./CrudLicenca.vue?vue&type=script&lang=ts"

import "./CrudLicenca.vue?vue&type=style&index=0&id=201365fc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-201365fc"

export default script